import { Popover } from '@material-ui/core';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import RestoreIcon from '@material-ui/icons/Restore';
import StarBorderOutlinedIcon from '@material-ui/icons/StarBorderOutlined';
import { FabExtraSmallMoreButton } from 'framework/components/buttons/FabExtraSmallMoreButton';
import { TextLinkButton } from 'framework/components/buttons/TextLinkButton';
import { AlertDialog } from 'framework/dialogs/AlertDialog';
import { useAnchorElement } from 'framework/hooks/useAnchorElement';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { entPhysiciansCommand_deleteOffice, entPhysiciansCommand_makeOfficeDefault, entPhysiciansCommand_restoreOffice, IOfficeData } from 'gen/ApiClient';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { useDialogsContext } from 'shared/dialogs/useDialogsContext';

interface IProps {
	item: IOfficeData;
	entPhysicianId: string;
	style?: React.CSSProperties;
	reload: VoidFunction;
}

export const EntPhysicianOfficeFab = ({ item, entPhysicianId, style, reload }: IProps) => {
	const strings = useLocalization();
	const [anchor, openMenu, closeMenu] = useAnchorElement();
	const { open, confirm, cancel } = useDialogsContext(reload);
	const [makeDefault] = useFormSubmit(entPhysiciansCommand_makeOfficeDefault);

	const onRestore = () => {
		closeMenu();
		open(
			<AlertDialog
				open
				content={strings.repairWhatQuestion(strings.office)}
				acceptText={strings.yesCommaSave}
				rejectText={strings.noCommaGoBack}
				reject={cancel}
				acceptF={() => entPhysiciansCommand_restoreOffice({ entPhysicianId: entPhysicianId, officeId: item.id })}
				accept={confirm}
			/>
		);
	};

	const onMakeDefault = async () => {
		closeMenu();
		const r = await makeDefault({ entPhysicianId: entPhysicianId, officeId: item.id });
		if (r.isSuccess) {
			reload();
		}
	};

	const onDelete = () => {
		closeMenu();
		open(
			<AlertDialog
				open
				content={strings.deleteWhatQuestion(strings.office)}
				acceptText={strings.yesCommaDelete}
				rejectText={strings.noCommaGoBack}
				reject={cancel}
				acceptF={() => entPhysiciansCommand_deleteOffice({ entPhysicianId: entPhysicianId, officeId: item.id })}
				accept={confirm}
			/>
		);
	};

	return (
		<>
			<FabExtraSmallMoreButton
				style={style}
				onClick={openMenu}
			/>
			{Boolean(anchor) && (
				<Popover
					open={Boolean(anchor)}
					anchorEl={anchor}
					onClose={closeMenu}>
					<div
						className='df-col'
						style={{ padding: 12 }}>
						<TextLinkButton
							startIcon={<StarBorderOutlinedIcon />}
							onClick={onMakeDefault}
							disabled={item.isDefault}>
							{strings.makeDefaultOffice}
						</TextLinkButton>
						{item.isDeleted === false && (
							<TextLinkButton
								startIcon={<DeleteOutlineIcon />}
								hoverColor='secondary'
								onClick={onDelete}>
								{strings.delete}
							</TextLinkButton>
						)}
						{item.isDeleted === true && (
							<TextLinkButton
								startIcon={<RestoreIcon />}
								hoverColor='secondary'
								onClick={onRestore}>
								{strings.repairVerb}
							</TextLinkButton>
						)}
					</div>
				</Popover>
			)}
		</>
	);
};
